import { render, staticRenderFns } from "./CardBook.vue?vue&type=template&id=0c148c21&scoped=true"
import script from "./CardBook.vue?vue&type=script&lang=js"
export * from "./CardBook.vue?vue&type=script&lang=js"
import style0 from "../styles/CardBook.css?vue&type=style&index=0&id=0c148c21&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c148c21",
  null
  
)

export default component.exports